import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const KvkkNotice = () => {
  const { t } = useTranslation();
  const sections = ['controller', 'processed', 'purposes', 'legal', 'transfer', 'rights', 'contact'];

  return (
    <div className="grid grid-cols-10 pb-28">
      <div className="col-start-2 col-span-8 mt-14">
        <h1 className="text-45 mb-4">{t('kvkk.title')}</h1>
        <p className="text-16 font-light text-customGray mb-10">{t('kvkk.intro')}</p>

        <div className="space-y-10">
          {sections.map((key) => (
            <section key={key}>
              <h2 className="text-24 font-medium mb-3">{t(`kvkk.${key}.title`)}</h2>
              <p className="text-16 font-light text-customGray leading-relaxed whitespace-pre-line">
                {t(`kvkk.${key}.text`)}
              </p>
            </section>
          ))}
        </div>

        <p className="text-16 font-light text-customGray mt-10">
          {t('kvkk.seeAlso')}{' '}
          <Link to="/cerez-politikasi" className="underline">
            {t('footer.cookiePolicy')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default KvkkNotice;
